import React from 'react';
import { SelectField } from 'components/forms';
import NewCardForm from 'components/invoice/newCardForm';

export default class extends React.Component {
    static propTypes = {
        cards: React.PropTypes.array.isRequired,
        errors: React.PropTypes.object.isRequired,
        onFormChanged: React.PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            newCardOpen: false,
            cardSelected: props.cards.length > 0 ? props.cards[0].id : 'new',
            cards: props.cards,
            newCard: {},
        };
    }

    handleCardSelected = (option) => {
        const val = option.value;

        this.setState({
            newCardOpen: val === 'new',
            cardSelected: val,
        }, () => {
            this.props.onFormChanged(this.state.cardSelected, this.state.cardSelected === 'new' ? this.state.newCard : this.state.cardSelected);
        });
    };

    handleCardFormChanged = (data) => {
        this.setState({ newCard: data }, () => {
            this.props.onFormChanged(this.state.cardSelected, this.state.cardSelected === 'new' ? this.state.newCard : this.state.cardSelected);
        });
    };

    render() {
        const cards = this.props.cards.map(card => {
            return { value: card.id, label: `************${card.last4}` };
        });

        cards.push({ value: 'new', label: 'New Card' });

        return (
            <div className="card-selector">
                <SelectField
                    name="card-selector"
                    label="Choose Card"
                    width="style"
                    value={this.state.cardSelected}
                    onChange={this.handleCardSelected}
                    options={cards}
                />

                {this.state.cardSelected === 'new' && <hr />}
                {this.state.cardSelected === 'new' && <NewCardForm errors={this.props.errors} onFormChanged={this.handleCardFormChanged} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/leads/cardSelector.jsx